import React, { Component } from 'react';
import Carousel from '../../components/Carousel';
import './Gallery.css';
import * as watches from '../../components/Watch/watches.json';

export default class Projects extends Component {

  state = {
    gallery: {
      name: "",
      slides: []
    }
  }

  componentDidMount = () => {
    this.props.setPage(this.props.name);
    switch(this.props.name){
      case "watches": this.setState({ gallery: watches}); break;
      default: ;
    }
  }

  render() {
    return (
      <div className="gallery"> 
        <Carousel slides={this.state.gallery.slides}/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/Gallery/Gallery.js